import {
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_ERROR,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_ERROR,
  LOAD_ADDRESS_REQUEST,
  LOAD_ADDRESS_SUCCESS,
  LOAD_ADDRESS_ERROR,
  ADD_ADDRESS_REQUEST,
  ADD_ADDRESS_SUCCESS,
  ADD_ADDRESS_ERROR,
  EDIT_ADDRESS_SUCCESS,
  EDIT_ADDRESS_ERROR,
  LOAD_POSTCODE_REQUEST,
  LOAD_POSTCODE_SUCCESS,
  LOAD_POSTCODE_ERROR,
  CLEAR_POSTCODE_ERROR,
  CLEAR_ADDRESS_FORM,
  LOAD_CONTACTS_REQUEST,
  LOAD_CONTACTS_SUCCESS,
  LOAD_CONTACTS_ERROR,
  DELETE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_ERROR,
  ADD_CONTACT_REQUEST,
  ADD_CONTACT_SUCCESS,
  ADD_CONTACT_ERROR,
  CLEAR_CONTACT_ERROR,
  EDIT_CONTACT_SUCCESS,
  EDIT_CONTACT_ERROR,
  DELETE_CONTACT_SUCCESS,
  DELETE_CONTACT_ERROR,
  GET_CARD_ERROR,
  GET_CARD_SUCCESS,
  ADD_CARD_REQUEST,
  ADD_CARD_SUCCESS,
  ADD_CARD_ERROR,
  CLEAR_CARD_ERROR,
  EDIT_CARD_SUCCESS,
  EDIT_CARD_ERROR,
  DELETE_CARD_SUCCESS,
  DELETE_CARD_ERROR,
  KICKBOX_SUCCESS,
  KICKBOX_ERROR,
  CLEAR_PROFILE_ERRORS,
  RESET_ADDRESS_ERROR,
  LEAVE_BABY_CLUB_SUCCESS,
  LEAVE_BABY_CLUB_ERROR,
} from '../actions/constants'

import { getMainAddressString } from '../helpers/address-helper'

const initialState = {
  getProfileSuccess: false,
  getProfileError: false,
  getProfileErrorCode: '',
  dataLoaded: false,
  additionalInfo: {
    firstName: '',
  },
  basic: {
    marketingPreference: 'n',
  },
  profileId: '',
  addresses: [],
  contacts: [],
  cards: [],
  isCardExists: false,
  addCardError: false,
  cardErrorMsg: '',
  isContactError: false,
  invalidContact: '',
  isPostcodeError: false,
  invalidPostcode: '',
  mainAddress: '',
  suggestedAddresses: [],
  suggestedAddress: '',
  isBabyClubMember: false,
}

const getProfileAttribute = (res, attrName) => {
  const { profileAttributes = [] } = res
  if (profileAttributes.length) {
    const migrated = profileAttributes.find(attr => attr.attributeName === attrName) || false
    return typeof migrated === 'object'
  }
  return false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_PROFILE_ERRORS:
      return {
        ...state,
        errorDescription: '',
        profileHasError: false,
        apiError: '',
        addContactError: '',
        phoneUserNameError: '',
        deleteAddressWarning: '',
      }
    case GET_PROFILE_REQUEST:
      return { ...state, isLoading: true }
    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        profileGetSuccess: true,
        dataLoaded: true,
        isBabyClubMember: getProfileAttribute(action.response, 'btc'),
        ...action.response,
        ...action.response.profile,
      }
    case GET_PROFILE_ERROR:
      return {
        ...state,
        ...action.response,
        profileGetError: true,
        profileGetCode: action.response.errorCode,
      }
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        ...action.response,
        profile: {
          basic: action.response.basic,
          additionalInfo: action.response.additionalInfo,
        },
      }
    case UPDATE_PROFILE_ERROR:
      return {
        ...state,
        ...action.response,
        profileHasError: true,
        apiError: action.response.errorDescription,
        phoneUserNameError: action.response.errorCode === 'SECONDARY_LOGIN_UPDATE_FAILED' ? action.response.errorDescription : '',
      }
    case LOAD_ADDRESS_REQUEST:
      return { ...state, isFetching: true }
    case LOAD_ADDRESS_SUCCESS:
    case EDIT_ADDRESS_SUCCESS:
      return {
        ...state,
        addresses: action.response.addresses,
        mainAddress: getMainAddressString(action.response.addresses),
      }
    case LOAD_ADDRESS_ERROR:
      return { ...state, ...action.response, error: true }
    case ADD_ADDRESS_REQUEST:
      return { ...state, ...action }
    case ADD_ADDRESS_SUCCESS:
      return {
        ...state,
        addresses: action.response.addresses,
        mainAddress: getMainAddressString(action.response.addresses),
        suggestedAddresses: null,
        suggestedAddress: null,
      }
    case ADD_ADDRESS_ERROR:
      return { ...state, ...action }
    case DELETE_ADDRESS_SUCCESS:
      return { ...state, ...action.response, errorDescription: '' }
    case DELETE_ADDRESS_ERROR:
      return {
        ...state,
        ...action.response,
        deleteCardAddressWarning: action.response.errorCode === 'ASDA_ADDRESS_IN_USE',
        deletePermissionAddressWarning: action.response.errorCode === 'ADDRESS_USED_IN_PREFERENCE',
        deletePermissionContactWarning: false,
      }
    case RESET_ADDRESS_ERROR:
      return {
        ...state,
        deleteCardAddressWarning: false,
        deletePermissionAddressWarning: false,
        deletePermissionContactWarning: false,
      }
    case EDIT_ADDRESS_ERROR:
      return { ...state, ...action }
    case LOAD_CONTACTS_REQUEST:
      return { ...state, isFetching: true }
    case LOAD_CONTACTS_SUCCESS:
      return { ...state, ...action.response }
    case LOAD_CONTACTS_ERROR:
      return { ...state, ...action.response, error: true }
    case ADD_CONTACT_REQUEST:
      return {
        ...state,
        ...action,
        addContactError: '',
      }
    case ADD_CONTACT_SUCCESS:
      return { ...state, ...action.response }
    case ADD_CONTACT_ERROR:
      return {
        ...state,
        invalidContact: action.errorDescription,
        error: true,
        isContactError: true,
        addContactError: action.errorDescription,
        ...action,
      }
    case EDIT_CONTACT_SUCCESS:
      return { ...state, ...action }
    case EDIT_CONTACT_ERROR:
      return { ...state, ...action }
    case DELETE_CONTACT_SUCCESS:
      return { ...state, ...action }
    case DELETE_CONTACT_ERROR:
      return {
        ...state,
        ...action,
        deletePermissionContactWarning: action.response.errorCode === 'CONTACT_USED_IN_PREFERENCE',
        deleteCardAddressWarning: false,
        deletePermissionAddressWarning: false,
      }
    case LOAD_POSTCODE_REQUEST:
      return { ...state, isFetching: true }
    case LOAD_POSTCODE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isPostcodeError: false,
        invalidPostcode: '',
        suggestedAddresses: action.formattedAddress.length > 1 ? action.formattedAddress : null,
        suggestedAddress: action.formattedAddress.length === 1 ? action.formattedAddress[0] : null,
        suggestedAddressMessage: action.message,
      }
    case LOAD_POSTCODE_ERROR:
      return {
        ...state,
        isFetching: false,
        ...action.response,
        isPostcodeError: true,
        error: true,
        invalidPostcode: action.errorDescription,
      }
    case CLEAR_CONTACT_ERROR:
      return {
        ...state,
        isContactError: false,
        error: false,
        invalidContact: '',
      }
    case CLEAR_POSTCODE_ERROR:
      return {
        ...state,
        isPostcodeError: false,
        invalidPostcode: '',
      }
    case CLEAR_ADDRESS_FORM:
      return {
        ...state,
        suggestedAddress: {},
      }
    case GET_CARD_SUCCESS:
    case GET_CARD_ERROR:
      return {
        ...state,
        isFetching: false,
        ...action.reposnse,
      }
    case ADD_CARD_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case ADD_CARD_SUCCESS:
    case EDIT_CARD_SUCCESS:
      return {
        ...state,
        isFetching: false,
        ...action.response,
      }
    case ADD_CARD_ERROR:
      return {
        ...state,
        isFetching: false,
        isCardExists: action.errorCode === 'CARD_EXISTS',
        addCardError: action.errorCode !== 'CARD_EXISTS',
        cardErrorMsg: action.errorDescription,
        ...action,
      }
    case CLEAR_CARD_ERROR:
      return {
        ...state,
        isCardExists: false,
        addCardError: false,
        error: false,
      }
    case EDIT_CARD_ERROR:
      return {
        ...state,
        isFetching: false,
        addCardError: true,
        cardErrorMsg: action.errorDescription,
        ...action,
      }
    case DELETE_CARD_SUCCESS:
      return { ...state, ...action.response }
    case DELETE_CARD_ERROR:
      return { ...state, ...action }
    case KICKBOX_SUCCESS:
    case KICKBOX_ERROR:
      return {
        ...state,
        ...action.response,
        kickbox: action.response.validationMessage || '',
      }
    case LEAVE_BABY_CLUB_SUCCESS:
      return { ...state, ...action.response }
    case LEAVE_BABY_CLUB_ERROR:
      return { ...state, ...action }
    default:
      return state
  }
}
